import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "m15.832 9.583-5.91 5.945a3.85 3.85 0 0 1-2.73 1.137 3.85 3.85 0 0 1-2.73-1.137 3.9 3.9 0 0 1-1.13-2.746c0-1.03.407-2.018 1.13-2.746l5.91-5.946a2.566 2.566 0 0 1 3.64 0 2.597 2.597 0 0 1 0 3.662l-5.916 5.945a1.283 1.283 0 0 1-1.82 0 1.3 1.3 0 0 1 0-1.83l5.46-5.487"
    }, null, -1)
  ])))
}
export default { render: render }